import { ErrorState } from "$components/error-state";
import { useAuth0 } from "@auth0/auth0-react";
import type { FC, ReactNode } from "react";
import { FormattedMessage } from "react-intl";

interface Props {
  title?: ReactNode;
  body?: ReactNode;
  errorDescription?: string;
}

export const Auth0ErrorPage: FC<Props> = ({
  title,
  body,
  errorDescription,
}) => {
  const { loginWithRedirect } = useAuth0();
  const isDevelopment = ["localhost", "127.0.0.1"].includes(
    window.location.hostname,
  );

  function handleBackToLogin() {
    loginWithRedirect({ prompt: "login" });
  }

  // Devs were seeing this error quite a lot when working locally,
  // 90% of the time it was just that one of the services hadn't started properly
  const defaultTitle = isDevelopment ? (
    "Authentication error"
  ) : (
    <FormattedMessage
      id="auth.errorPage.defaultTitle"
      defaultMessage="Unauthorised"
    />
  );
  const defaultMessage = isDevelopment ? (
    (errorDescription ?? "Please retry or contact your ePOCUS administrator.")
  ) : (
    <FormattedMessage
      id="auth.errorPage.body"
      defaultMessage="Please contact your ePOCUS administrator for assistance."
    />
  );

  return (
    <ErrorState
      title={title || defaultTitle}
      body={body || defaultMessage}
      onRetry={handleBackToLogin}
      retryLabel={
        <FormattedMessage
          id="auth.errorPage.retry"
          defaultMessage="Try again"
        />
      }
      contactSupport={false}
    />
  );
};
